module.exports = __webpack_public_path__ + "assets/img/0661.3e6046ef.png";